import React from "react";
import { handleOverDrop, handleDragEnterLeave } from "./DragDropEvents";
export const DragDrop = ({
  question,
  exercise_id,
  section_id,
  page_id,
  data_possible_type,
  answer,
  possible_answer_number,
}) => {
  return (
    <span className="contentremove">
      <span contentEditable={false}>
      <span className="data_id d-none">{`[[${possible_answer_number}]]`}</span>
      <div
        data-question-id={question.id}
        exercise_id={exercise_id}
        section_id={section_id}
        page_id={page_id}
        data_possible_type={data_possible_type}
        data-possible-answer-number={possible_answer_number}
        data-placeholder="Drag the Box here"
        data-tc="DragBox"
        className="dotted-border user-select text-nowrap inline-grid input_badge"
        data-drop-target="true"
        onDragEnter={handleDragEnterLeave}
        onDragLeave={handleDragEnterLeave}
        onDrop={handleOverDrop(answer)}
        onDragOver={handleOverDrop(undefined)}
      ></div>
      </span>
    </span>
  );
};
